<template>
    <div>
        <Loader :loading="loading" absolute="true"/>

        <v-data-table
                :headers="headers"
                :items="activationsList"
                hide-actions>
            <template slot="headerCell"
                      slot-scope="{ header }">
              <span class="subheading
                              font-weight-light
                              text-success
                              text--darken-3"
                    v-text="header.text"/>
            </template>
            <template
                    slot="items"
                    slot-scope="{ item }">
                <td class="text-xs-left">{{ item.options.serial_number }}</td>

                <td class="text-xs-left min-width">
                     <span v-if="item.options.vendor">{{ item.options.vendor.name }}</span>      
                </td>

                <td class="text-xs-left min-width">
                     <span v-if="item.options.code">{{ item.options.code }}</span>      
                </td>

                <td class="text-xs-left">
                                         <span v-if="item.options.product_info">{{ item.options.product_info.vendor_code }}</span>      
                </td>
                <td class="text-xs-left">
                                         <span v-if="item.options.product_info">{{ item.options.product_info.name }}</span>      
                </td>
                <td class="text-xs-left">{{ item.reward }}</td>
                <td class="text-xs-right">{{ item.created_at | dateTime }}</td>
            </template>


        </v-data-table>

        <v-pagination
                v-if="last_page>1"
                v-model="page"
                class="my-4"
                :length="last_page"
        ></v-pagination>


    </div>

</template>

<script>
    import Loader from "../../helper/Loader";
    import {mapMutations} from 'vuex';
    import ProductCard from "../ProductCard";

    import {VueEditor} from 'vue2-editor'

    export default {
        components: {ProductCard, Loader},
        props: ['user'],
        data: () => ({
            loading: true,
            dialog: false,
            activationsList: [],
            orderID: null,
            currentOrder: null,

            count: 0,
            page: 1,
            last_page: 0,

            headers: [
                {
                    sortable: false,
                    text: 'Серийный номер',
                    value: 'serial_number'
                },
                       {
                    sortable: false,
                    text: 'Отгрузка',
                    value: 'vendor.name'
                },
                {
                    sortable: false,
                    text: 'Секретный ключ',
                    value: 'code'
                },
         
                {
                    sortable: false,
                    text: 'Артикул',
                    value: 'product.vendor_code'
                },
                {
                    sortable: false,
                    text: 'Товар',
                    value: 'product.title'
                },
                {
                    sortable: false,
                    text: 'Балл',
                    value: 'reward'
                },
                {
                    sortable: false,
                    text: 'Дата активации',
                    value: 'created_at',
                    align: 'right'
                }
            ],
        }),
        methods: {
            ...mapMutations(['SET_PRODUCT_CARD']),
            getActivations() {
                this.loading = true;
                axios.get('admin/activations-dealer', {
                    params: {
                        per_page: 10,
                        page: this.page,
                        dealer_id: this.user,
                    }
                }).then(response => {
                    this.activationsList = response.data.data;
                    this.loading = false;
                    this.last_page = response.data.last_page;
                }).catch(error => {

                });
            },
        },
        created() {
            setTimeout(() => {
                this.getActivations();
            }, 300)
        },
        watch: {
            page() {
                setTimeout(() => {
                    this.getActivations();
                }, 300)
            }
        },
    }
</script>

<style>

</style>
